exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-run-pdf-viewer-wrapper {\n  padding-top: 24px;\n}\n.test-run-pdf-viewer-wrapper .react-pdf__Document {\n  justify-content: center;\n}\n.test-run-pdf-viewer-wrapper .test-run-pdf-viewer-content-wrapper .ant-pagination {\n  text-align: center;\n}\n", ""]);

// exports
